export const EVENT = {
    LOADED: 'LOADED',
    SCROLL: 'SCROLL',
    EXPERIENCE_LOADED: 'EXPERIENCE_LOADED'
}